<template>
  <div class="profile-general">
    <div class="profile-general__form">
      <bh-text-input
        label="Mobile number"
        v-model="userData.phone"
        showConfirmEdit
        :editButtonRight="true"
        :readonlyAsSpan="true"
        prependIcon="bhi-cellphone"
        inputEditingBackgroundClass="bhBlue4"
        @input="inputUpdate"
      />
      <bh-text-input
        label="Email address"
        v-model="userData.email"
        showConfirmEdit
        :editButtonRight="true"
        :readonlyAsSpan="true"
        :editModeEnabled="editModeEnabled"
        prependIcon="bhi-email"
        inputEditingBackgroundClass="bhBlue4"
        @input="inputUpdate"
        @update:editModeEnabled="handleEmailEditMode"
      />
      <div class="input-group">
        <label>Password</label>
        <span class="input-readonly">
          <v-icon color="accent">bhi-lock</v-icon> *********
        </span>
      </div>
      <div class="profile-general__button--wrap">
        <v-btn
          elevation="0"
          text
          color="accent"
          target="_blank"
          @click="openChangePassword"
        >
          Change password
        </v-btn>
      </div>
      <div class="input-group">
        <bh-select
          class="mb-3"
          label="Chat language (BETA)"
          v-model="userData.language"
          :items="languagesDictionary"
          item-text="text"
          item-value="value"
          @input="inputUpdate"
        />
      </div>
      <v-snackbar v-model="notificationSnackbar">
        {{ notificationSnackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="notificationSnackbar = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { apiInstance } from '@/api/api.js'
import BhTextInput from '@/components/inputs/BhTextInput.vue'
import BhSelect from '@/components/inputs/BhSelect.vue'
import Config from '@/config.json'
import LanguagesMixin from '@/mixins/languages'

export default {
  name: 'ProfileGeneral',
  mixins: [LanguagesMixin],
  components: {
    BhTextInput,
    BhSelect,
  },
  data: () => ({
    notificationSnackbar: false,
    notificationSnackbarText: '',
    changePasswordUrl: Config.VUE_APP_CAS_URL + '/change-password',
    editModeEnabled: false,
    isEmailEditing: false,
    userData: {},
  }),
  computed: {
    ...mapState('userStates', ['user']),
    ...mapGetters({
      getProfileId: 'userStates/getProfileId',
    }),
  },
  methods: {
    ...mapActions('chatStates', ['unmountChatService']),
    ...mapActions('userStates', ['getProfile', 'updateProfile', 'logoutUser']),
    logout() {
      this.unmountChatService()
      this.logoutUser()
    },
    clearEditMode() {
      this.editModeEnabled = false
      this.notificationSnackbar = false
      this.notificationSnackbarText = ''
      this.isEmailEditing = false
    },
    async inputUpdate() {
      const wasEmailEditing = this.isEmailEditing
      this.clearEditMode()

      try {
        await this.updateProfile({
          profileId: this.getProfileId,
          data: { ...this.userData },
        })

        if (wasEmailEditing) {
          this.logout()
        }
      } catch (error) {
        console.error('Failed to update profile:', error)

        this.userData = this.user ? { ...this.user } : {}
      }
    },
    async openChangePassword() {
      try {
        const api = apiInstance()
        const response = await api.post('/profiles/changePassword')
        const token = response.data.token
        window.location.href = `${this.changePasswordUrl}?token=${token}`
      } catch (error) {
        console.error('Failed to request change password token:', error)
      }
    },
    handleEmailEditMode(enabled) {
      this.editModeEnabled = enabled
      this.isEmailEditing = enabled

      if (enabled) {
        this.notificationSnackbarText =
          'Changing email address will log you out from the system.'
        this.notificationSnackbar = true
      }
    },
  },
  watch: {
    user(val) {
      this.userData = val ? { ...val } : {}
    },
  },
  mounted() {
    this.getProfile({ profileId: this.getProfileId })
  },
}
</script>

<style lang="scss">
@import '@/styles/variables';

.profile-general {
  padding: 40px;

  &__form {
    max-width: 336px;
  }

  &__button {
    &--wrap {
      margin: 0 -21.3333333333px;
    }
  }

  .input-readonly {
    display: flex;
    align-items: center;
    justify-items: flex-start;
    color: $bh-gray--1;
    font-weight: 700;
    width: 100%;
    height: 48px;
    font-size: 1.1428rem;
    line-height: 1.25em;

    .v-icon {
      width: 16px;
      min-width: 16px;
      margin-right: 22px;
    }
  }

  .bh-text-input {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .bh-text-input__label,
  label {
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.425em;
    color: $bh-gray--2;
    margin-bottom: 3px;
  }
}
</style>
